module.exports = function getResource (label, vars = []) {
    const resources = {
        checkout: 'Checkout'
    };

    return resources[label];
};
